/**
 * Created by mabiao on 2017/11/22.
 */
// 懒加载
// /* webpackChunkName: "part1" */  注释为相同数据代码块的归类命名
const OldIndex = () => import(/* webpackChunkName: "part1" */ '../pages/index/index.vue'); //首页
const Index = () => import(/* webpackChunkName: "part1" */ '../pages/index/newIndex.vue'); //首页
const IndexMsg = () => import(/* webpackChunkName: "part1" */ '../pages/index/indexMsg.vue'); //首页

const AskIndex = () => import(/* webpackChunkName: "part1" */ '../pages/ask/index.vue'); //问题详情页面

const UsercateList = () => import(/* webpackChunkName: "part3" */ '../pages/usercate/list.vue'); // 老师列表首页
const HighAnswerList = () =>
	import(/* webpackChunkName: "part3" */ '../pages/usercate/highList.vue'); // 老师列表首页

//=== 答主首页 ====
const AnswerIndex = () => import(/* webpackChunkName: "part4 */ '../pages/user/index.vue'); // 老师首页
const AnsweredList = () => import(/* webpackChunkName: "part5" */ '../pages/user/answered.vue'); // 老师首页回答了问题列表
const CommendList = () => import(/* webpackChunkName: "part5" */ '../pages/user/commendList.vue'); // 老师首页评价列表页面
const ChatPaySuc = () => import(/* webpackChunkName: "part5" */ '../pages/user/chatPaySuc.vue'); // 老师首页评价列表页面

//=== 答主首页 ====
//=== 闪测模块 ====

const ScIndex = () => import(/* webpackChunkName: "part6" */ '../pages/sc/index.vue'); // 闪测首页
const ScCateList = () => import(/* webpackChunkName: "part6" */ '../pages/sc/catelist.vue'); // 类别详情
const ScDetail = () => import(/* webpackChunkName: "part7" */ '../pages/sc/detail.vue'); // 下单详情页
const ScFeedback = () => import(/* webpackChunkName: "part7" */ '../pages/sc/feedback.vue'); // 反馈页面
const ScComment = () => import(/* webpackChunkName: "part7" */ '../pages/sc/comment.vue'); // 反馈页面
const ScHotlist = () => import(/* webpackChunkName: "part7" */ '../pages/sc/hotlist.vue'); // 热门闪测列表
const ScGreat = () => import(/* webpackChunkName: "part7" */ '../pages/sc/great.vue'); // 热门闪测列表
//=== 闪测模块 END ====

//=== 个人中心模块 ====
const MeIndex = () => import(/* webpackChunkName: "part8" */ '../pages/me/index.vue'); // 个人首页
const MeTyrants = () => import(/* webpackChunkName: "part9" */ '../pages/spare/tyrants.vue'); // 我的打赏榜
const MeSpare = () => import(/* webpackChunkName: "part9" */ '../pages/spare/spare.vue'); // 打赏
const MeQuestions = () => import(/* webpackChunkName: "part10" */ '../pages/me/asks.vue'); // 我的普通问题列表
const taluoAsks = () => import(/* webpackChunkName: "part10" */ '../pages/me/taluoAsks.vue'); // 塔罗问题列表
const tfChat = () => import(/* webpackChunkName: "part10" */ '../pages/me/tfChat.vue'); // 塔罗问题列表
const taluoSms = () => import(/* webpackChunkName: "part10" */ '../pages/me/taluoSms.vue'); // 塔罗问题列表
const MePersonQuestions = () =>
	import(/* webpackChunkName: "part10" */ '../pages/chatroom/chatList.vue'); // 我的个人问题列表
const MeQian = () => import(/* webpackChunkName: "part11" */ '../pages/me/myQian.vue'); // 我的个人问题列表
const MeCesuan = () => import(/* webpackChunkName: "part11" */ '../pages/me/myCesuan.vue'); // 我的测算列表

const MeAskDetail = () => import(/* webpackChunkName: "part12" */ '../pages/ask/askAgain.vue'); // 我的问题详情列表
const CsDetail = () => import(/* webpackChunkName: "part12" */ '../pages/ask/csDetail.vue'); // 我的问题测算详情
const TarotResult = () => import(/* webpackChunkName: "part12" */ '../pages/ask/tarotResult.vue'); // 我的问题测算详情
const Tarot2Result = () => import(/* webpackChunkName: "part12" */ '../pages/ask/tarot2Result.vue'); // 我的问题测算详情
const Tarot3Result = () => import(/* webpackChunkName: "part12" */ '../pages/ask/tarot3Result.vue'); // 我的问题测算详情
const Tarot4Result = () => import(/* webpackChunkName: "part12" */ '../pages/ask/tarot4Result.vue'); // 我的问题测算详情
const TzAskDetail = () => import(/* webpackChunkName: "part12" */ '../pages/ask/tzAskDetail.vue'); // 我的问题详情列表
const taluoAskDetail = () =>
	import(/* webpackChunkName: "part12" */ '../pages/ask/taluoAskDetail.vue'); // 塔罗问题详情
const MeTouting = () => import(/* webpackChunkName: "part12" */ '../pages/me/touting.vue'); // 我听页面
const MeIncome = () => import(/* webpackChunkName: "part12" */ '../pages/me/income.vue'); // 我的收入页面
const MeFeedback = () => import(/* webpackChunkName: "part12" */ '../pages/me/feedback.vue'); // 我的收入页面
const MeAgreement = () => import(/* webpackChunkName: "part12" */ '../pages/me/agreement.vue'); // 协议页面
const MeWelcome = () => import(/* webpackChunkName: "part12" */ '../pages/me/welcome.vue'); // 协议页面
const MyOrder = () => import(/* webpackChunkName: "part12" */ '../pages/me/myOrder.vue'); // 我的订单

//=== 个人中心模块 END ====

//=== 打赏模块 ====

const SpareSuccess = () =>
	import(/* webpackChunkName: "part9" */ '../pages/spare/spareSuccess.vue'); // 打赏成功

//=== 打赏模块 END ====

//=== 搜索模块 ====
const SearchIndex = () => import(/* webpackChunkName: "part14" */ '../pages/search/search.vue'); // 搜索首页
const SearchList = () => import(/* webpackChunkName: "part14" */ '../pages/search/searchList.vue'); // 搜索首页
//=== 搜索模块 END ====

//=== 优惠券列表 ====
const Coupon = () => import(/* webpackChunkName: "part14" */ '../pages/coupon/index.vue'); // 优惠券列表
//=== 优惠券列表 END ====

//=== 404模块 END ====
// const NotFindPage = () => import(/* webpackChunkName: "part16" */ '../pages/notFindPage.vue');

//=== 握手咨询室模块 ===
const handsChatRoom = () =>
	import(/* webpackChunkName: "part18" */ '../pages/handsChatRoom/chatRoom.vue');
//=== 握手咨询室模块 END ===

//=== 免费咨询室模块 ===
const freeChatRoom = () =>
	import(/* webpackChunkName: "part18" */ '../pages/freeChatRoom/chatRoom.vue');
const topic = () => import(/* webpackChunkName: "part18" */ '../pages/freeChatRoom/topic.vue');
const setChatRoom = () =>
	import(/* webpackChunkName: "part18" */ '../pages/freeChatRoom/setting.vue');
const consultList = () =>
	import(/* webpackChunkName: "part18" */ '../pages/freeChatRoom/consultList.vue');
const tfChatRoom = () =>
	import(/* webpackChunkName: "part18" */ '../pages/freeChatRoom/tfChatRoom.vue');
const tfChatRoom2 = () =>
	import(/* webpackChunkName: "part18" */ '../pages/freeChatRoom/tfChatRoom2.vue');
//=== 免费咨询室模块 END ===
const MeMessages = () => import(/* webpackChunkName: "part10" */ '../pages/me/messages.vue'); // 我的消息中心列表

//=== 快速提问 ===
const quickStep1 = () => import(/* webpackChunkName: "part19" */ '../pages/quick/quickStep1.vue');
const quickStep2 = () => import(/* webpackChunkName: "part19" */ '../pages/quick/quickStep2.vue');
const quickStep3 = () => import(/* webpackChunkName: "part19" */ '../pages/quick/quickStep3.vue');
const newQuickStep3 = () =>
	import(/* webpackChunkName: "part19" */ '../pages/quick/newQuickStep3.vue');
const quickStep4 = () => import(/* webpackChunkName: "part19" */ '../pages/quick/quickStep4.vue');

//=== 快速提问 END ===

//=== 课程模块 ===
const courseIndex = () => import(/* webpackChunkName: "part18" */ '../pages/course/index.vue');
const courseDetail = () =>
	import(/* webpackChunkName: "part18" */ '../pages/course/course_detail.vue');
const courseIng = () => import(/* webpackChunkName: "part18" */ '../pages/course/course_ing.vue');
const myCourse = () => import(/* webpackChunkName: "part18" */ '../pages/course/my_course.vue');
const tuwenDetail = () =>
	import(/* webpackChunkName: "part18" */ '../pages/course/tuwen_detail.vue');
//=== 课程模块 END ===

// 支付成功后的页面
const paySucGuide = () => import(/* webpackChunkName: "part18" */ '../pages/user/paySucGuide.vue');

//售后服务
const Complaint = () => import(/* webpackChunkName: "part21" */ '../pages/afterSale/complaint.vue');
const ComplaintProgress = () =>
	import(/* webpackChunkName: "part27" */ '../pages/afterSale/complaintProgress.vue');
const Help = () => import(/* webpackChunkName: "part24" */ '../pages/me/help.vue');
const FamilarQuestion = () =>
	import(/* webpackChunkName: "part25" */ '../pages/me/familiarQuestion.vue');
const BusinessRule = () => import(/* webpackChunkName: "part25" */ '../pages/me/businessRule.vue');
const QuestionDetail = () =>
	import(/* webpackChunkName: "part26" */ '../pages/me/questionDetail.vue');
/* 商城start */
const mallIndex = () => import(/* webpackChunkName: "part28" */ '../pages/mall/index.vue'); //商城首页
const mallDetail = () => import(/* webpackChunkName: "part28" */ '../pages/mall/mall_detail.vue'); //商城详情
const mallList = () => import(/* webpackChunkName: "part28" */ '../pages/mall/mall_list.vue'); //商城列表
const shopOrder = () => import(/* webpackChunkName: "part28" */ '../pages/mall/shopOrder.vue'); // 商品订单列表
const goodsOrder = () => import(/* webpackChunkName: "part28" */ '../pages/mall/goodsOrder.vue'); // 商品订单列表
const shopOrderDetail = () =>
	import(/* webpackChunkName: "part28" */ '../pages/mall/shopOrderDetail.vue'); // 商品订单列表
const goodsOrderDetail = () =>
	import(/* webpackChunkName: "part28" */ '../pages/mall/goodsOrderDetail.vue'); // 商品订单列表
const notify = () => import(/* webpackChunkName: "part28" */ '../pages/me/notify.vue'); //心得消息通知
const shopMonentList = () =>
	import(/* webpackChunkName: "part28" */ '../pages/mall/shopMonentList.vue'); //心得消息通知
//=== 商城搜索模块 ====
const searchShop = () => import(/* webpackChunkName: "part14" */ '../pages/search/searchShop.vue'); // 搜索首页
const searchListShop = () =>
	import(/* webpackChunkName: "part14" */ '../pages/search/searchListShop.vue'); // 搜索首页
//=== 商城搜索模块 END ====
// 我的关注页
const follow = () => import(/* webpackChunkName: "part22" */ '../pages/me/follow.vue');

/* 秒杀活动start */
const SecKill = () => import(/* webpackChunkName: "part28" */ '../pages/seckill/index.vue');
/* 秒杀活动end */

//增加八字信息模块
const addBazi = () => import(/* webpackChunkName: "part28" */ '../pages/quick/addBazi.vue');
//快速提问老师列表
const teacherList = () => import(/* webpackChunkName: "part28" */ '../pages/quick/teacherList.vue');

//免费咨询室中转页
const mFreeChatRoom = () =>
	import(/* webpackChunkName: "part19" */ '../pages/static/mFreeChatRoom.vue');

//塔罗打开页
const taluo = () => import(/* webpackChunkName: "part29" */ '../pages/taluo/index.vue'); //首页
//塔罗支付
const taluoPay = () => import(/* webpackChunkName: "part29" */ '../pages/taluo/pay.vue'); //首页

//h5订单页下载引导
const h5order = () => import(/* webpackChunkName: "part19" */ '../pages/static/h5order.vue');

//=== 偷听问题收益页面 ===
const spreadTing = () => import(/* webpackChunkName: "part30" */ '../pages/touting/index.vue');
const moneyTing = () => import(/* webpackChunkName: "part30" */ '../pages/touting/money.vue');

//=== 运势模块 ===
const newSignIndex = () => import(/* webpackChunkName: "part31" */ '../pages/sign/newIndex.vue'); // 运势详情页

//=== 协议 ===
const privacyProtocol = () =>
	import(/* webpackChunkName: "part32" */ '../pages/xy/privacyProtocol.vue'); // 隐私协议
const userProtocol = () => import(/* webpackChunkName: "part32" */ '../pages/xy/userProtocol.vue'); // 用户协议
//=== 快速提问end ===

// 咨询室评价
const evaluation = () =>
	import(/* webpackChunkName: "part32" */ '../pages/freeChatRoom/evaluation.vue');

// 高级服务详情页
const serviceDetail = () => import(/* webpackChunkName: "part33" */ '../pages/service/detail.vue');

const feedback = () => import(/* webpackChunkName: "part34" */ '../pages/feedback/index.vue');
const feedbackSubmit = () =>
	import(/* webpackChunkName: "part35" */ '../pages/feedback/submit.vue');
const FollowQiWei = () => import(/* webpackChunkName: "part36" */ '../pages/me/FollowQiWei.vue');
const consultIndex = () => import('../pages/consult/index.vue');

export default {
	mode: 'history',
	// base:'/app',
	// scrollBehavior (to, from, savedPosition) {
	// 	return { x: 0, y: 0 }
	// },
	routes: [
		{
			/* 首页页面 */
			path: '/',
			meta: {
				index: 0
			},
			component: Index
		},
		{
			/* 首页页面 */
			path: '/OldIndex',
			meta: {
				index: 0
			},
			component: OldIndex
		},

		{
			/* 塔罗首页页面 */
			path: '/taluo',
			component: taluo
		},
		{
			/* 塔罗支付页面 */
			path: '/taluoPay',
			component: taluoPay
		},

		{
			/* 首页页面 */
			path: '/indexMsg',
			meta: {
				index: 0
			},
			component: IndexMsg
		},
		{
			/* 偷听页面 */
			path: '/askIndex',
			component: AskIndex
		},
		{
			/* 老师列表 */
			path: '/usercateList',
			meta: {
				index: 1
			},
			component: UsercateList
		},
		{
			/* 咨询Tab */
			path: '/consultIndex',
			meta: {
				index: 1
			},
			component: consultIndex
		},
		{
			/* 高价老师列表 */
			path: '/highAnswerList',
			component: HighAnswerList
		},
		{
			/* 老师首页 */
			path: '/answerIndex',
			component: AnswerIndex
		},
		{
			/* 老师首页回答了问题的页面 */
			path: '/answeredList',
			component: AnsweredList
		},
		{
			/* 老师首页评价列表页面 */
			path: '/commendList',
			component: CommendList
		},
		{
			/* 高价服务订单页面 */
			path: '/chatPaySuc',
			component: ChatPaySuc
		},
		{
			/* 个人中心 */
			path: '/meIndex',
			meta: {
				index: 3
			},
			component: MeIndex
		},
		{
			/* 打赏榜单 */
			path: '/MeTyrants',
			component: MeTyrants
		},
		{
			/* 打赏页面 */
			path: '/MeSpare',
			component: MeSpare
		},
		{
			/* 我的普通问题 */
			path: '/MeQuestions',
			component: MeQuestions
		},
		{
			/* 塔罗问题列表 */
			path: '/taluoAsks',
			component: taluoAsks
		},
		{
			/* 投放引导下载 */
			path: '/tfChat',
			component: tfChat
		},
		{
			/* 塔罗问题列表 */
			path: '/taluoSms',
			component: taluoSms
		},
		{
			/* 我的个人问题 */
			path: '/MePersonQuestions',
			component: MePersonQuestions
		},
		{
			/* 我的问题详情 */
			path: '/MeAskDetail',
			component: MeAskDetail
		},
		{
			/* 测算详情 */
			path: '/CsDetail',
			component: CsDetail
		},
		{
			/* 算法专题测算详情 */
			path: '/tarotResult',
			component: TarotResult
		},
		{
			/* 算法专题测算详情 */
			path: '/tarot2Result',
			component: Tarot2Result
		},
		{
			/* 算法专题测算详情 */
			path: '/tarot3Result',
			component: Tarot3Result
		},
		{
			/* 算法专题测算详情 */
			path: '/tarot4Result',
			component: Tarot4Result
		},
		{
			// 知屿APP问题详情页面
			path: '/tzAskDetail',
			component: TzAskDetail
		},
		{
			/* 塔罗问题详情 */
			path: '/taluoAskDetail',
			component: taluoAskDetail
		},
		/* 我听页面 */
		{
			path: '/MeTouting',
			component: MeTouting
		},
		/* 我的收入页面 */
		{
			path: '/MeIncome',
			component: MeIncome
		},
		/* 我的反馈页面 */
		{
			path: '/MeFeedback',
			component: MeFeedback
		},
		/* 我的答主申请页面 */
		{
			path: '/MeWelcome',
			component: MeWelcome
		},
		/* 协议页面 */
		{
			path: '/MeAgreement',
			component: MeAgreement
		},
		{
			path: '/scIndex',
			meta: {
				index: 2
			},
			component: ScIndex
		},
		{
			path: '/ScCateList',
			component: ScCateList
		},
		{
			path: '/ScDetail',
			component: ScDetail
		},
		{
			path: '/ScFeedback',
			component: ScFeedback
		},
		{
			path: '/ScComment',
			component: ScComment
		},
		{
			path: '/ScHotlist',
			component: ScHotlist
		},
		{
			/* 打赏成功后 */
			path: '/SpareSuccess',
			component: SpareSuccess
		},
		{
			/* 搜索首页 */
			path: '/SearchIndex',
			component: SearchIndex
		},
		{
			/* 搜索结果页 */
			path: '/SearchList',
			component: SearchList
		},
		{
			path: '/CouponIndex',
			component: Coupon
		},
		{
			path: '/meQian',
			component: MeQian
		},
		{
			path: '/meCesuan',
			component: MeCesuan
		},
		{
			path: '*',
			// component:Index,
			redirect: '/'
		},
		{
			path: '/handsChatRoom',
			component: handsChatRoom
		},
		{
			/*免费咨询室专题引导页*/
			path: '/topic',
			component: topic
		},
		{
			/*免费咨询室*/
			path: '/freeChatRoom',
			component: freeChatRoom
		},
		{
			/*咨询室评价*/
			path: '/evaluation',
			component: evaluation
		},
		{
			/*免费咨询室，用于投放*/
			path: '/tfChatRoom',
			component: tfChatRoom
		},
		{
			/*免费假咨询室，用于算法订单*/
			path: '/tfChatRoom2',
			component: tfChatRoom2
		},
		{
			// 聊天室设置
			path: '/setChatRoom',
			component: setChatRoom
		},
		{
			// 咨询记录
			path: '/consultList',
			component: consultList
		},
		{
			/* 消息中心 */
			path: '/MeMessages',
			component: MeMessages
		},
		{
			/* 快速提问 */
			path: '/quickStep1',
			component: quickStep1
		},
		{
			/* 快速提问 */
			path: '/quickStep2',
			component: quickStep2
		},
		{
			/* 快速提问 */
			path: '/quickStep3',
			component: quickStep3
		},
		{
			/* 快速提问 */
			path: '/newQuickStep3',
			component: newQuickStep3
		},
		{
			/* 快速提问 */
			path: '/quickStep4',
			component: quickStep4
		},
		{
			/*课程首页*/
			path: '/courseIndex',
			component: courseIndex
		},
		{
			/*课程详情*/
			path: '/courseDetail',
			component: courseDetail
		},
		{
			/*课程详情*/
			path: '/courseIng',
			component: courseIng
		},
		{
			/*我的课程列表*/
			path: '/myCourse',
			component: myCourse
		},
		{
			/*课程学习图文信息*/
			path: '/tuwenDetail',
			component: tuwenDetail
		},
		{
			/*支付成功后的引导页面*/
			path: '/paySucGuide',
			component: paySucGuide
		},
		{
			// 投诉
			path: '/complaint',
			component: Complaint
		},
		{
			// 投诉进度
			path: '/complaintProgress',
			component: ComplaintProgress
		},
		{
			// 帮助中心
			path: '/help',
			component: Help
		},
		{
			// 常见问题
			path: '/familarQuestion',
			component: FamilarQuestion
		},
		{
			// 业务规则
			path: '/businessRule',
			component: BusinessRule
		},
		{
			// 表单详情
			path: '/questionDetail',
			component: QuestionDetail
		},
		{
			//商城首页
			path: '/mallIndex',
			component: mallIndex
		},
		{
			//商城详情
			path: '/mallDetail',
			component: mallDetail
		},
		{
			//商城列表
			path: '/mallList',
			component: mallList
		},
		{
			// 商品订单列表
			path: '/shopOrder',
			component: shopOrder
		},
		{
			// 商品订单列表
			name: 'goodsOrder',
			path: '/goodsOrder',
			component: goodsOrder,
			meta: {
				hideFooter: true
			}
		},
		{
			// 商品订单详情
			path: '/shopOrderDetail',
			component: shopOrderDetail
		},
		{
			// 商品订单详情
			path: '/goodsOrderDetail',
			component: goodsOrderDetail,
			meta: {
				hideFooter: true
			}
		},
		{
			// 心得消息通知
			path: '/notify',
			component: notify
		},
		{
			// 心得全部评论
			path: '/shopMonentList',
			component: shopMonentList
		},
		{
			// 商城搜索
			path: '/searchShop',
			component: searchShop
		},
		{
			// 商城搜索列表
			path: '/searchListShop',
			component: searchListShop
		},
		{
			// 我的关注
			path: '/follow',
			component: follow
		},
		{
			// 精选测算
			path: '/ScGreat',
			component: ScGreat
		},
		{
			// 七天秒杀
			path: '/seckill',
			component: SecKill
		},
		{
			//增加八字信息页面
			path: '/addBazi',
			component: addBazi
		},
		{
			//快速提问老师列表页
			path: '/teacherList',
			component: teacherList
		},
		{
			// 免费咨询室打开中转页
			path: '/mFreeChatRoom',
			component: mFreeChatRoom
		},
		{
			// h5订单引导页
			path: '/h5order',
			component: h5order
		},
		//偷听
		{
			path: '/spreadTing',
			component: spreadTing
		},
		{
			path: '/moneyTing',
			component: moneyTing
		},
		{
			// 每日签到
			path: '/newSign',
			component: newSignIndex
		},
		{
			// 用户协议
			path: '/userProtocol',
			component: userProtocol
		},
		{
			// 隐私协议
			path: '/privacyProtocol',
			component: privacyProtocol
		},
		{
			// 高级服务详情页
			path: '/serviceDetail',
			component: serviceDetail
		},
		{
			// 投诉页
			path: '/feedback',
			component: feedback
		},
		{
			// 投诉提交页
			path: '/feedbackSubmit',
			component: feedbackSubmit
		},
		{
			// 我的订单
			path: '/myOrder',
			component: MyOrder
		},
		{
			// 关注企微
			path: '/FollowQiWei',
			component: FollowQiWei
		}
	]
};



// WEBPACK FOOTER //
// ./src/router/index.js